<form class="forget-form" [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
 


  <div class="form-group">
      <label class="control-label">FULL NAME</label>
      <input class="form-control" formControlName="FullName" type="text"  placeholder="ENTER FULL NAME HERE"
      [ngClass]="{ 'is-invalid': submitted && signUpFormControls.FullName.errors }">
  </div>


  <div class="form-group">
      <label class="control-label">APPLICATION TYPE</label>

      <select formControlName="ApplicationTypeId"  class="form-control" 
      [ngClass]="{ 'is-invalid': submitted && signUpFormControls.ApplicationTypeId.errors }">
          <option value="">PLEASE SELECT APPLICATION TYPE</option>
          <option *ngFor="let item of applicationTypes; let i=index" value="{{item.ApplicationTypeId}}">{{item.Name}}</option>
                
      </select>
  </div>


  <div class="form-group">
          <label class="control-label">EMAIL</label>
          <input formControlName="Email" class="form-control" type="text" placeholder="ENTER YOUR EMAIL"
          [ngClass]="{ 'is-invalid': submitted && signUpFormControls.Email.errors }">
  </div>

  <div class="form-group">
            
            <div class="inline-dev">
              <div class="country-code">
                  <label class="control-label">COUNTRY CODE</label>
                  <input formControlName="CountryCode" type="text" class="form-control" placeholder="eg. 233"
                  [ngClass]="{ 'is-invalid': submitted && signUpFormControls.CountryCode.errors }">  
              </div>
              <div class="phone-number">
                  <label class="control-label">PHONE NO.</label>

                  <input formControlName="PhoneNumber" type="text" class="form-control" placeholder="eg. 549947594"
                  [ngClass]="{ 'is-invalid': submitted && signUpFormControls.PhoneNumber.errors }">
  
              </div>
            </div>
           

  </div>

  <div class="form-group btn-container">

      <button class="btn btn-primary btn-block" 
      [disabled]="!signUpForm.valid">
      <i [ngClass]="{'fa fa-refresh fa-spin': showLoadingIndicator}"></i>
      GENERATE LOGIN</button>




  </div>
      <div class="text-center pt-3">
                <!-- <hr> -->
            <p class="text-muted">Developed by <a href="http://www.qfacegroup.com"> QFace Group GH.</a></p>
            </div>
</form>
